import { render, staticRenderFns } from "./finger2.vue?vue&type=template&id=74875e00&"
import script from "./finger2.vue?vue&type=script&lang=js&"
export * from "./finger2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports